export default "__VITE_ASSET__SBWcgRTI__"